module.exports = __webpack_public_path__ + "static/media/Paus hörnsoffa 2 rekliner micro grå bistro miljö modell 1 2023.c997b938.jpg";